var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "font-weight-bold mb-2" }, [
        _vm._v("\n\t\tInteresse von " + _vm._s(_vm.applicantName) + "\n\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3" }, [_vm._v(_vm._s(_vm.text))]),
      _vm._v(" "),
      _c("JonInfo", {
        staticClass: "mb-3",
        scopedSlots: _vm._u([
          {
            key: "message",
            fn: function() {
              return [
                _c("div", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n\t\t\t\tBitte leite die nächsten Schritte mit " +
                      _vm._s(_vm.applicantName) +
                      " ein."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\tE-Mail Adresse und Telefonnummer wurden nun von " +
                      _vm._s(_vm.applicantName) +
                      " freigegeben. Diese findest du unter\n\t\t\t\t"
                  ),
                  _c("b", [_vm._v("Zusagen")]),
                  _vm._v(".\n\t\t\t")
                ]),
                _vm._v(" "),
                _c("div", [_c("b", [_vm._v("Gratulation!")])])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("Button", {
            attrs: { text: "Schließen", icon: "checkmark" },
            on: { click: _vm.submit }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }